import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video",
  "use": "icon-video-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 18\" id=\"icon-video\"><g clip-path=\"url(#icon-video_clip0_7551_23602)\"><path d=\"M3.5 2.25c-.82 0-1.5.68-1.5 1.5v10.5c0 .82.68 1.5 1.5 1.5h12c.82 0 1.5-.68 1.5-1.5V3.75c0-.82-.68-1.5-1.5-1.5h-12zm0 1.5h12v10.5h-12V3.75zM7.25 6v6l5.25-3-5.25-3z\" /></g><defs><clipPath id=\"icon-video_clip0_7551_23602\"><path d=\"M0 0h18v18H0z\" transform=\"translate(.5)\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol